<template>
    <Page v-if="isUserInGroup('partner')" :header="(!isPWA && !isTgApp) ? header[lang_].title : ''" type='gray'>
        <template v-slot:body>
            <Data :show_invite="show_invite" @show="setShow" />
            <TaskList @show_invite="showInvite" />
        </template>
    </Page>
    <Page v-else >
        <template v-slot:body>
            <Be />
        </template>
    </Page>
</template>

<script>
import Connect      from "@/assets/js/Connect";
import Helper       from "@/assets/js/Helper";
import Be           from "@/components/personal/partner/Be.vue";
import Data         from "@/components/personal/partner/Data.vue";
import TaskList     from "@/components/personal/partner/TaskList.vue";
import PartnerInfo  from "@/components/personal/partner/PartnerInfo.vue";
import Page         from "@/components/sides/Page.vue";
import { mapActions } from "vuex";

export default {
    data() {
        return {
            confirmed: null,
            show_invite: false,
            header: {
                ru: {
                    title: "Кабинет партнера",
                },
                en: {
                    title: "Partner cabinet",
                },
            },
        };
    },
    components: {
        Page,
        Data,
        Be,
        PartnerInfo,
        TaskList,
    },
    computed: {
        lang_() { return this.$i18n.locale ? this.$i18n.locale : "ru" },
        isPWA: function () { return this.$store.getters.StatePWA },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        screenSize() { return this.$store.getters.StateScreenSize },
        confirmed() { return this.$store.getters.StatePartnerConfirmed },
    },
    methods: {
        isUserInGroup (type) { return this.helper.isUserInGroup(type, this.$store.getters.StateGroups)},
        showInvite(val) {
            this.show_invite = val;
        },
        setShow(val) {
            this.show_invite = val;
        },
        ...mapActions(['SetHeaderTitle', 'SetHeaderBtnLeftFirst', 'SetHeaderBtnLeftSecond', 'SetHeaderBtnRightFirst', 'SetHeaderBtnRightSecond']),
    },
    async beforeCreate() {
        this.connect = new Connect();
        this.helper = new Helper();
    },
    mounted() {
        this.confirmed = this.$store.getters.StatePartnerConfirmed;
        this.helper.SetTgAppBackButton(false)

        try {
            this.SetHeaderTitle(this.header[this.lang_].title)
            this.SetHeaderBtnLeftFirst({
                type: 'backward',
                icon: 'pi pi-arrow-left',
                class: 'text-xs',
                rounded: true,
                severity: 'secondary',
                visible: true,
            })
            this.SetHeaderBtnLeftSecond({})
            this.SetHeaderBtnRightFirst({
                type: 'link',
                link: '/support/',
                icon: 'pi pi-comments',
                class: 'text-xs',
                rounded: true,
                severity: 'secondary',
                visible: true,
            })
            this.SetHeaderBtnRightSecond({})
        } catch (error) {
            console.error('Error setting header:', error)
        }
    },
};
</script>
